export const ENV_URL = import.meta.env.VITE_ENV_URL || '/emr-ui/';
export const BASE_URL = import.meta.env.VITE_GATEWAY_URL || 'https://rsh.lumenore.com/emr';
export const ROUTES: any = {
  // General
  home: '/',
  user: '/dashboard',
  about: '/about',
  LoginPage: '/login',
  RegisterPage: '/register-client',
  questionBankAvailablePage: '/questionBankAvailable',
  OrganizationPage: '/select-organization',
  changePassword: '/change-password',
  changePasswordWithLayout: '/changePassword',
  ForgotPassword: '/forgot-password',
  sendEmail: '/send-email',
  SignUp: '/signUp',
  LandingPage: '/landing-page',
  // Download Center
  downloadCenter: '/download-center',
  //Invoices
  InvoicesGridPage: '/invoices-grid',
  // Client Intake
  clientIntakeSentForInfo: '/client-intake-details-sentInfo/:id',
  ClientIntakeDetailsPage: '/client-intake-details-grid',
  clientIntakeDetails: '/client-intake-details',
  clientIntakeForm: '/client-intake-grid',
  ClientInquiryFormPage: '/clientInquiryFormPage',
  postSubmissionIntakeFormPage: '/post-submission-form-page',
  // Program Book
  programBookDetails: '/program-book',
  programBook: '/program-book/:id',
  programBookView: '/program-book/:id/view',
  programBookMastered: '/program-book/:id/mastered',
  programBookDiscontinued: '/program-book/:id/discontinued',
  clientDocument: '/program-book/:id/client-document',
  domains: '/program-book/:id/domain/:domainId',
  programs: '/program-book/:id/domain/:domainId/program/:programId',
  target: '/program-book/:id/domain/:domainId/program/:programId/target/:targetId',

  // Mastery Criteria Template
  masterCriteriaTemplate: '/master-criteria-template-grid',
  MasteryCriteriaLandingPageUrl: '/mastery-criteria-template',
  phase: '/master-criteria-template/:phase',
  masterCriteriaEdit: '/master-criteria-template/:name/:id',
  masterCriteriaView: '/master-criteria-template/:name/:id/:mode',
  // Session Management
  sessionGrid: '/session-grid',
  sessionTranscriptionGrid: '/session-transcriptions',
  sessionNoteGrid: '/session-note-grid',
  sessionCreateNote: '/session-note',
  editSessionNote: '/session-note/:id',
  viewSessionNote: '/session-note/view/:id',
  createSession: '/create-session',
  runSession: '/run-session',
  editSession: '/edit-session',
  viewSession: '/view-session',
  sessionNote: '/session-note',
  addNewEvent: '/add-new-event',
  sessionHistory: '/sessionHistory',
  // Scheduling
  scheduling: '/scheduling',
  appointmentDetails: '/appointment-details',
  // Guideline Template
  guidelineGrid: '/guideline-grid',
  guidelineTemplate: '/guideline-template',
  guidelineTemplateEdit: '/guideline-template/:id',
  guidelineTemplateView: '/guideline-template/view/:id',
  // Library
  programBookLibrary: '/program-book-library',
  programBookLibraryLanding: '/program-book-library-landing/:id',
  componentLibraryGrid: '/document-template/component-library',
  // Authorization Code
  authorizationCodeGrid: '/authorizationCodeGrid',
  AuthorizationCodePage: '/authorization-code-page',
  // Roles and Groups
  RolesGrid: '/roles-grid',
  AddNewRoles: '/add-roles',
  editRole: '/edit-role',
  groupsGrid: '/groupsGrid',
  addNewGroup: '/add-new-group',
  viewGroup: '/view-group',
  // Intervention
  interventionGrid: '/interventionGrid',
  interventionLanding: '/interventionLanding',
  interventionLandingClientDoc: '/interventionLanding/:interventionId/clientDoc',
  interventionLandingClientDocView: '/interventionLanding/:interventionId/view/clientDoc',
  interventionDomainScreen: '/interventionLanding/:interventionId/domain-screen/:domainId',
  interventionDomainScreenView: '/interventionLanding/:interventionId/view/domain-screen/:domainId',
  longTermGoal:
    '/interventionLanding/:interventionId/domain-screen/:domainId/longTermGoal/:longTermGoalId',
  longTermGoalScreenView:
    '/interventionLanding/:interventionId/view/domain-screen/:domainId/longTermGoal/:longTermGoalId',
  shortTermGoal:
    '/interventionLanding/:interventionId/domain-screen/:domainId/longTermGoal/:longTermGoalId/shortTermGoal/:shortTermGoalId',
  shortTermGoalScreenView:
    '/interventionLanding/:interventionId/view/domain-screen/:domainId/longTermGoal/:longTermGoalId/shortTermGoal/:shortTermGoalId',
  // Rate Management
  RateGrid: '/rate-grid',
  DefaultRateGrid: '/DefaultRateGrid',
  // User Onboarding and Insurance
  addUser: '/add-user',
  viewUser: '/view-user',
  payor: '/add-user/:id/payor-setting',
  viewPayor: '/view-user/:id/payor-setting',
  addInsurance: '/add-user/:id/payor-setting/add-insurance',
  viewInsurance: '/view-user/:id/payor-setting/view-insurance',
  authorization: '/add-user/:id/authorization-setting',
  viewAuthorization: '/view-user/:id/authorization-setting',
  contactGrid: '/contact-grid',
  //MyAccount
  myAccount: '/my-account',
  // Billing
  BillingGrid: '/billing',
  bulkClaims: '/bulk-merge-claims',
  bulkPayment: '/bulk-payment',
  // Goal Library
  goalLibraryPageGrid: '/GoalLibraryGridPage',
  goalLibraryLandingPage: '/GoalLibraryLanding',
  goalLibraryClientDocScreen: '/GoalLibraryLanding/:goalLibraryId/clientDoc',
  goalLibraryDomainScreen: '/GoalLibraryLanding/:goalLibraryId/domain-screen/:domainId',
  goalLibraryLongTermGoalScreen:
    '/GoalLibraryLanding/:goalLibraryId/domain-screen/:domainId/longTermGoal/:longTermGoalId',
  goalLibraryShortTermGoalScreen:
    '/GoalLibraryLanding/:goalLibraryId/domain-screen/:domainId/longTermGoal/:longTermGoalId/shortTermGoal/:shortTermGoalId',
  // Meta Data Management
  diagnosisCodeGrid: '/diagnosisCode-Grid',
  emailFormattingById: '/emailFormat-by-id/:id',
  // Claim Inbox
  inboxGrid: '/inbox',
  // Intake Form
  intakeForm: '/organizationsForm/intakeFormBuilder',
  viewIntake: '/organizationsForm/intakeFormBuilder/view/:id',
  // Dictionary
  DictionaryPage: '/dictionary-grid',
  // Authorization Management
  authorizationGrid: '/authorization-grid',
  // Organizations
  organizationsGrid: '/organizationsGrid',
  organizationsForm: '/organizationsForm',
  organizationsView: '/organizationsView',
  // Error Page
  error404: '/404',
  Error403: '/403',
  //organization setting
  organizationSetting: '/organization-setting',
  //medical record
  medicalRecordGrid: '/medical-records',
  previewCMSForm: '/preview-cms-forms',
  eraGrid: '/era',
  //Provider request
  providerRequestGrid: '/provider-request-grid',
  //Payment Reconciliation
  paymentReconciliationGrid: '/payment-reconciliation/:eraId',

  //Overlapping Appointment
  overlappingAppointmentGrid: '/overlapping-appointment',

  //Pre Billing Auditing
  preBillingAuditing: '/pre-billing-auditing',
};
export const URLS = {
  // Download Center
  getDownloadCenterList: '/core/download-centre/get-all-paginated-download-centre-data',
  downloadCenterFile: '/core/download-centre/download-file',
  programBookLibraryHistory:
    '/core/program-book-library-history/get-paginated-program-book-library-history-data',
  billingCodeHistory:
    '/core/authorization-code/get-authorization-code-history-by-authorization-code-id',
  goalLibraryHistory:
    '/core/intervention-library/get-intervention-plan-library-history-by-intervention-plan-id',
  getInvoiceGridData: '/core/invoice/get-all-paginated-invoices',
  getDeletedInvoice: '/core/invoice/get-all-paginated-deleted-invoices',
  invoiceToggle: '/core/invoice/invoice-toggle',
  deleteInvoice: '/core/invoice/delete-invoice',
  questionType: '/core/question-bank-management/get-question-bank-management-question-type',
  answerType: '/core/question-bank-management/get-question-bank-management-answer-type',
  saveQuestion: '/core/question-bank-management/save-question-bank-management',
  questionById: 'core/question-bank-management/get-question-bank-management-by-id',
  questionBankManagementGridApi:
    '/core/question-bank-management/get-paginated-question-bank-management',
  questionaBankManagementDelete: '/core/question-bank-management/delete-question-bank-management',
  wailistGridApi: '/core/wait-list/get-all-wait-list-data',
  clientIntakeDetailsById: '/core/organization/get-organization-intake-by-id',
  clientIntakeDetailsSave: '/core/organization/save-sent-for-information-form',
  saveFile: '/core/organization/save-sent-for-information-file',
  verifyProgramBook: '/core/program-book/verify-program-book-by-clientId',
  verifyIntervention: '/core/intervention-plan/verify-intervention-plan-by-clientId',
  saveAssignee: '/core/program-book/edit-program-book-assignee',
  saveGroup: '',
  test: '/test',
  getMine: '/core/program-book/get-all-paginated-program-book',
  getDomainByProgramBookId: '/core/domain/get-domain-by-programBookId',
  getDomainById: '/core/domain/get-domain-by-id',
  getProgramById: '/core/program/get-program-by-id',
  getProgramBookDataById: '/core/program-book/get-program-book-by-id',
  getProgramsByDomainId: '/core/program/get-program-by-domain-id',
  deleteProgramBookEntities: 'core/program-book/delete-program-book-entities',
  createDomain: '/core/domain/create-domain',
  checkDuplicateDomain: '/core/domain/check-duplicate-domain',
  checkDuplicateProgram: '/core/program/check-duplicate-programName',
  createProgram: '/core/program/create-program',
  getFiles: '/core/files/get-program-book-file-by-program-book-id',
  templateGridApiUrl: '/core/template/get-all-template',
  editDomain: '/core/domain/rename-domain',
  uploadDocument: '/core/files/save-program-book-file',
  createTemplate: '/core/template/create-template',
  renameProgram: '/core/program/rename-program',
  editTemplate: '/core/template/edit-template',
  saveDocument: '/core/document/save-program-book-document',
  getDocument: '/core/document/get-program-book-document-by-id',
  editProgram: '/core/program/edit-program',
  getExportedTargetData: '/core/program-book/export-program-book-data',
  exportProgramBookGraph: '/core/download-centre/export-program-book-graph',
  findByTemplate: '/core/template/find-by-id-template',
  checkDuplicateTemplate: '/core/template/check-duplicate-template-name',
  getTemplateName: '/core/template/get-all-template-name',
  programTypes: '/core/organization/get-program-data-types',
  getAllDocument: '/core/document/get-program-book-document-by-program-book-id',
  getClientInsurance: '/core/organization/get-all-insurance',
  getClientServices: '/core/organization/get-all-services',
  getClientLocations: '/core/organization/get-all-locations',
  getClientAvailabilityStatus: '/core/organization/get-all-status',
  checkDuplicateClientName: '/core/document/check-duplicate-program-book-document-name',
  // intake form
  SaveClientInquiryFrom: '/core/organization/save-organization-intake',
  ClientIntakeDetails: '/core/organization/get-all-intakes-by-org-id',
  organizationLocation: '/core/organization/get-organization-location',
  organizationLink: '/core/organization/generate-enquiry-link',
  renameProgramBook: '/core/program-book/rename-program-book',
  setTargetIndex: '/core/target/set-target-index-count',
  getABCData: '/core/abc-data/get-abc-data-by-program-book-id',
  getOrganizationIntakeById: '/core/organization/get-organization-intake-by-id',
  organizationName: '/core/organization/get-organization-name-by-code',
  sentForInformation: '/core/organization/send-for-more-info',
  availabilityDropdown: '/core/wait-list/get-all-availability-dropdown-data',
  organizationLocationByCode: '/core/organization/get-organization-location-by-code',
  insurancesByCode: '/core/organization/get-all-insurance-by-code',
  servicesByCode: '/core/organization/get-all-services-by-code',
  ///Library
  getProgramBookLibrary: '/core/library/get-all-program-book-library',
  saveProgramBookLibrary: '/core/library/save-program-book-library',
  deleteProgramBookLibrary: '/core/library/delete-program-book-library',
  copyProgramBookLibrary: '/core/library/copy-program-book-library',
  getDomainByProgramBookUUidLibrary: '/core/domain/get-domain-by-library-id',
  getProgramBookLibraryDataById: '/core/library/get-program-book-library-by-id',
  renameLibraryName: '/core/library/rename-program-book-library',
  renameDomainLib: '/core/library/rename-program-book-library-domain',
  renameProgramLib: '/core/library/rename-program-book-library-program',
  renameTargetLib: '/core/library/rename-program-book-library-target',
  deleteProgramBookLibraries: '/core/library/delete-program-book-library-entities',
  //Master Criteria Template
  clearValueInMasterCriteria:
    '/core/mastery-criteria-template/clear-mastery-criteria-and-set-default-values',
  saveCriteriaTemplate: '/core/mastery-criteria-template/save-criteria-template',
  getMasteryCriteriaTemplate:
    '/core/mastery-criteria-template/get-mastery-criteria-template-by-template-id',
  getMasteryCriteriaTemplateById:
    '/core/mastery-criteria-template/get-mastery-criteria-template-by-id',
  getTemplate: '/core/mastery-criteria-template/get-template-by-id',
  getProgressOrRegress:
    '/core/mastery-criteria-template/get-mastery-criteria-template-auto-progress-or-regress-by-phase',
  publishMasteryCriteria: '/core/mastery-criteria-template/publish-mastery-criteria-template',
  unPublishMasteryCriteria: '/core/mastery-criteria-template/unpublish-mastery-criteria-template',
  copyMasteryCriteria: '/core/mastery-criteria-template/copy-mastery-criteria-template',
  //Master Criteria Form
  getTimeFrame: '/core/mastery-criteria-template/get-mastery-criteria-template-timeframe-by-type',
  getAutoProgress:
    '/core/mastery-criteria-template/get-mastery-criteria-template-auto-progress-by-phase',
  getAutoRegress:
    '/core/mastery-criteria-template/get-mastery-criteria-template-auto-regress-by-phase',
  saveCriteriaTemplateForm: '/core/mastery-criteria-template/save-mastery-criteria-template',
  isMasteryCardsAvailable: 'core/mastery-criteria-template/count-of-mastery-criteria-template',
  isToggleChange: 'core/mastery-criteria-template/change-mastery-criteria-to-general',
  checkStatusActiveAndInactive:
    '/core/mastery-criteria-template/change-mastery-criteria-template-status',
  deleteMaintenance: '/core/mastery-criteria-template/delete-maintenance-criteria',
  ///target/create-target
  getTargetById: '/core/target/get-target-by-id',
  saveTarget: '/core/target/create-target',
  getTargetHistory: '/core/target/get-session-run-history-data-by-target-id',
  checkDuplicateTarget: '/core/target/check-duplicate-target-name',
  checkDuplicateTargetInProgram: '/core/target/check-duplicate-target-name-in-program',
  getUsers: '/core/organization/get-all-active-employees',
  getAssignTo: '/core/organization/get-all-ABA-clinicians',
  createClientProgramBook: '/core/program-book/create-program-book',
  renameTarget: '/core/target/rename-target',
  getStatus: '/core/program-book/get-all-status',
  getPhase: '/core/program-book/get-all-phase',
  phaseChange: '/core/program-book/set-phase',
  statusChange: '/core/program-book/set-status',
  editTargets: '/core/target/edit-target',
  copyTarget: '/core/target/copy-target',
  // session APIs
  checkDuplicateSessionName: '/core/session/check-duplicate-session-name',
  createSession: '/core/session/create-session',
  getProgramBooksForUser: '/core/program-book/get-program-book-by-user-child-id',
  getAllUsers: '/core/organization/get-all-user-child',
  getSessionTargets: '/core/target/get-all-target-by-session-id-and-type',
  getTrialsByTarget: '/core/session/get-all-trails-by-session-target-id',
  getTrialsByTargetForTaskAnalysis:
    '/core/session/get-all-task-analysis-trails-by-session-target-id',
  runSession: '/core/session/run-session',
  saveTrial: '/core/session/save-trail',
  undoTrial: '/core/session/undo-trial',
  getSessionById: '/core/session/get-session-by-id',
  endSession: '/core/session/end-session',
  getAllTargetsBySession: '/core/session/get-all-session-target-by-session-id',
  sessionHistory: '/core/session/get-session-run-history-data',
  getTargetRunSummary: '/core/session/get-target-run-summary-data',
  editSession: '/core/session/edit-session',
  deleteSession: '/core/session-note/delete-session-note-data-by-id',
  fetchSessionsByClientId: '/core/session/get-all-session-by-client-id',
  fetchSessionSummary: '/core/session/get-all-session-run-summary-by-client-id',
  addToSession: '/core/session/add-target-to-session',
  getProgrambookDocumentsByProgramBookId:
    '/core/document/get-program-book-documents-by-programbook-id',
  getLastThreeTargetDataPointByTargetId:
    '/core/target/get-last-three-target-data-point-by-target-id',
  //add-target-from-program
  getMasteryCriteriaName: '/core/mastery-criteria-template/get-mastery-name-by-data-type',
  getPhaseForProgram: '/core/program/get-all-program-phase',
  //session
  getSessionGridData: '/core/session/get-all-session',
  getAllTranscription: '/core/transcription/get-all-transcription',
  getAllTarget: '/core/target/get-all-target-by-program',
  sessionNote: '/core/session-note/get-all-paginated-session-note-template',
  sessionExistingNote: '/core/session-note/get-all-existing-session-notes',
  //file
  downloadFileUrl: '/core/files/download-file',
  deleteFileURL: '/core/files/delete-program-book-file',
  //user landing
  userProfileData: '/core/user-profile/get-user-profile-by-user-id',
  getUserChiildByid: '/core/user-profile/get-user-child-by-id',
  clientAppointments: '/core/client-information/get-upcoming-appointments-data',
  employeeAppointment: '/core/client-information/get-technician-upcoming-appointments-data',
  notes: '/core/client-information/get-technician-dashboard-notes-data',
  emptyNotes: '/core/client-information/get-technician-dashboard-empty-session-notes-data',
  currentGoal: '/core/client-information/get-current-goal-data',
  insurances: '/core/user-insurance/get-child-insurance-providers-by-client-id',
  clientSession: '/core/client-information/get-client-session-data',
  productivity: '/core/client-information/get-clinician-dashboard-productivity-data',
  referringProvider: '/core/organization/get-referring-providers-by-client-id',
  myDocument: '/core/client-information/get-document-data',
  inquiries: './core/client-information/get-intake-coordinator-dashboard-data',
  authorizations: '/core/client-information/get-intake-coordinator-authorization-dashboard-data',
  intakes: '/core/client-information/get-intake-coordinator-waitlist-dashboard-data',
  clientInvoice: '/core/invoice/client-dashboard-invoice',
  primaryRolePermission: '/core/authorization/get-primary-role-permissions',
  getAllChild: '/core/client-children/get-all-client-child-by-user-id',
  getParticularChild: '/core/client-children/get-child-info-by-id',
  getEthinicity: '/core/client-children/get-ethnicity',
  saveChild: '/core/client-children/save-client-child',
  unitAndVisit: '/core/client-authorization/get-client-authorization-unit-and-visit-by-client-id',
  unitAndVisitByClientId:
    '/core/client-authorization/get-client-authorization-unit-and-visit-by-client-children-id',
  upcommingProgressNote:
    '/core/client-information/get-clinician-or-technician-upcoming-progress-note-data',
  //login
  login: '/identity/auth/login',
  changePassword: '/core/auth/change-password',
  getUserPermission: '/core/authorization/get-user-permission',
  sendEmailForForgotPassword: '/identity/auth/forgot-password',
  savePassword: '/core/auth/save-forgot-password-user',
  logout: '/core/auth/logout',
  generateCaptcha: '/identity/auth/generate-captcha',
  validateCaptcha: '/identity/auth/validate-captcha',
  //comments
  saveComment: '/core/comment/save-comment',
  deleteComment: '/core/comment/delete-comment-by-id',
  getComments: '/core/comment/get-all-comment',
  markRead: '/core/session/mark-comments-as-read',
  saveCommentsByClinician: '/core/comment/save-comment-by-clinician',
  getAllProgramLibraries: '/core/library/get-program-book-libraries',
  addFromLibrary: '/core/program-book/add-from-library',
  //all roles
  getAllRoles: '/core/authorization/get-all-roles',
  //authorization code and billable code
  authorizationBillableCode: '/core/authorization-code/get-authorization-code-by-type',
  editAuthorizationCode: 'core/authorization-code/get-authorization-code-by-id',
  changeBillingStatus: '/core/authorization-code/change-billing-code-status',
  //user onboarding
  getContactGrid: '/core/user-profile/get-all-user-profile',
  getHistoryById: '/core/auth/get-user-history-by-id',
  saveEmployee: '/core/user-profile/save-employee',
  getEmployeeById: '/core/user-profile/get-user-profile-by-id',
  editEmployee: '/core/user-profile/edit-employee',
  primaryDiagnosisCode: '/core/user-profile/get-all-diagnosis-code',
  userChild: '/core/organization/get-user-childs-by-user-id',
  saveClientInsurance: '/core/user-insurance/add-insurance-for-client',
  parentInfo: '/core/user-insurance/fetch-parent-information',
  deleteAuthorizationFile: '/core/user-insurance/delete-client-authorization-file-by-id',
  downloadClientInsurance: '/core/user-insurance/download-client-file',
  addOtherPayor: '/core//user-insurance/add-other-payor-for-client',
  getOtherPayor: '/core/user-insurance/get-client-other-payors',
  getOtherPayorById: '/core/user-insurance/get-other-payor-by-id',
  deleteOtherPayors: '/core/user-insurance/delete-other-payor-by-id',
  resetLink: '/core/auth/reset-user-password',
  allSecondaryRoles: '/core/authorization/get-pending-roles-after-primary-role-selection',
  calculateTotalFrequency:
    '/core/user-insurance/calculate-frequency-by-frequency-type-and-total-amounts-and-total-hours',
  workLocation: '/core/user-profile/get-organization-location-by-org-id',
  organizationWorkLocation: '/core/organization/get-organization-location-dropdown-data',
  authCodeByServiceId:
    '/core/authorization-code/get-authorization-code-by-organization-services-id',
  deleteAdditionalEmail: '/core/user-profile/delete-additional-email-data',
  //Scheduling
  getClinicianAndTech: '/core/organization/get-all-active-employees',
  getScheduleEvent: '/core/scheduler/get-schedule-event-by-provider-id',
  primaryProvider: 'core/organization/get-all-active-employees',
  serviceProvider: '/core/organization/get-active-employees-for-service-provider',
  activeTechnician: '/core/organization/get-active-technician',
  primaryProviderActiveInactive: '/core/organization/get-all-employees-id-name',
  getAllAdditionalParticipants: '/core/organization/get-all-additional-participants',
  placeService: '/core/scheduler/get-all-service-places',
  authorizationNonBillable: '/core/authorization-code/get-authorization-code-by-user-id',
  scheduleEvent: '/core/scheduler/schedule-event',
  getClientData: '/core/scheduler/get-client-data-by-client-id',
  getScheduleEventById: '/core/scheduler/get-schedule-event-by-id',
  getEventsByProviders: '/core/scheduler/get-schedule-events-by-provider-ids',
  cancelAppointment: '/core/scheduler/cancel-schedule-event',
  cancelAllAppointment: '/core/scheduler/cancel-all-events-for-day',
  getAllUserAndGroupNames: '/core/organization/get-all-user-and-group',
  dragEvent: '/core/scheduler/drag-schedule-event',
  copyEvent: '/core/scheduler/copy-event',
  getAllEmployeesAndChild: '/core/organization/get-all-employees-and-child',
  getTechnicianAvailability:
    '/core/technician-availability-request/get-appointment-technician-availability-data',
  appointmentHistory: '/core/scheduler/get-appointment-history-by-id',
  //add new note
  getNoteByCode: '/core/session-note/get-session-note-template-by-id',
  getMultipleNoteByCode:
    '/core/session-note/get-multiple-session-note-template-by-authorization-code',
  saveAddNewNote: '/core/session-note/save-session-note',
  completeScheduleEvent: '/core/scheduler/complete-schedule-event',
  getAuthCodes: '/core/scheduler/get-authorization-code-by-event-id',
  setAuthCodes: '/core/scheduler/edit-authorization-code',
  editScheduleEvent: '/core/scheduler/edit-schedule-event',
  editCompleteScheduleEvent: '/core/scheduler/edit-complete-schedule-event',
  checkSessionNoteExists: 'core/session-note/check-session-note-for-billing-code-appointment',
  downloadSessionNote: 'core/pdf/generate-pdf',
  clientProviderDetails: '/core/organization/get-provider-client-data',
  interventionClientProviderDetails:
    '/core/organization/get-intervention-plan-provider-client-data',
  assignBulkProvider: '/core/scheduler/assign-bulk-provider-to-events',
  //roles
  getAllPermission: '/core/authorization/get-all-permissions',
  getUserPermissionByChildId: '/core/authorization/get-user-permission-by-child-id',
  CreateRole: '/core/authorization/create-role',
  editRole: '/core/authorization/get-permission-by-role-id',
  deleteRole: '/core/authorization/delete-role',
  roleHistory: '/core/authorization/get-organization-role-history-by-org-role-id',
  // organizations
  organizationsGrid: '/core/organization/get-all-paginated-organizations',
  saveOrganizations: '/core/organization/save-organization',
  getOrganizationsById: '/core/organization/get-organization',
  editOrganizationById: '/core/organization/edit-organization',
  getServicePlaces: '/core/scheduler/get-all-master-service-places',
  getOrgSpecificServicePlaces: '/core/scheduler/get-all-service-places',
  //Note
  copySessionNote: '/core/session-note/copy-session-note-data',
  getNoteById: '/core/session-note/get-session-note-data-by-id',
  getNameOfNote:
    '/core/session-note/get-session-notes-data-by-appointment-and-authorization-code-id',
  getAllMasteredPrograms: '/core/program/get-all-mastered-programs',
  getAllMasteredTargets: '/core/target/get-all-mastered-targets',
  getTargetTrialData: '/core/session/get-target-trail-data-by-target-id',
  getTargetSpecificTechnicianData: '/core/session/get-target-specific-technician-data',
  //Authorization Code
  authorizationCodeGrid: '/core/authorization-code/get-all-paginated-authorization-code',
  authorizationCodeMetaData: '/core/authorization-code/get-authorization-code-metadata',
  saveAuthorizationCode: 'core/authorization-code/save-authorization-code',
  //Groups
  groupsGrid: '/core/organization/get-all-paginated-organizations',
  saveGroupPage: '/core/group/save-group',
  getAllEmployee: '/core/organization/get-all-employees',
  getGroupById: '/core/group/get-group-by-id',
  deleteGroup: '/core/group/delete-group',
  groupHistory: '/core/group/get-group-history-by-org-group-id',
  //Guideline Template Grid
  publishGuidelineTemplate: '/core/template/publish-guideline-template',
  unpublishGuidelineTemplate: '/core/template/unpublish-guideline-template',
  copyGuidelineTemplate: '/core/template/copy-guideline-template',
  deleteGuidelineTemplate: '/core/template/delete-guideline-template-by-template-id',
  //SessionNote Template Grid
  publishSessionNote: '/core/session-note/publish-session-note-template',
  unpublishSessionNote: '/core/session-note/unpublish-session-note-template',
  copySessionNoteTemplate: '/core/session-note/copy-session-note-template',
  deleteSessionNoteTemplate: '/core/session-note/delete-session-note-template-by-template-id',
  groupsGridPage: '/core/group/get-all-group',
  // Intervention
  getInterventionExportedData:
    '/core/intervention-plan/get-domain-long-term-short-term-goal-data-by-id',
  //Rate
  feeSchedule: '/core/rate/get-all-fee-schedule',
  saveCustomRate: '/core/rate/save-custom-rate',
  customRateGrid: '/core/rate/get-custom-rate-by-authorization-code',
  defaultRateGrid: '/core/rate/get-default-rate-by-authorization-code',
  saveDefaultRate: '/core/rate/save-default-rate',
  allClientForRate: '/core/organization/get-filter-user-child',
  allEmployeeForRate: '/core/organization/get-filter-employee',
  getDefaultRate: '/core//rate/get-default-rate',
  //billing
  paymentHistory: '/core/billing-amount/get-billing-history-data-by-billing-id',
  billingHistoryUrl: '/core/billing/get-paginated-billing-history-data',
  billingRateGrid: '/core/billing/get-all-paginated-billing',
  deleteBillingGrid: '/core/billing/delete-billing',
  billingSideModalUrl: 'core/billing/get-billing-by-id',
  billingStatementsUrl:
    '/core/billing-amount/get-selected-billing-data-for-print-statement-by-client-id-and-billing-id',
  billingPrAmtSaveUrl: 'core/billing/save-billing',
  getBillingCodeFromBilling: 'core/billing/get-all-billing-codes-from-billing',
  getBillableCodes: '/core/authorization-code/get-authorization-code-data-by-code-type',
  getAllbillingPatient: 'core/billing/get-all-billing-patients',
  getAllbillingPayor: 'core/billing/get-all-payor-from-billing',
  getProviderNamesFromBilling: 'core/billing/get-all-provider-name-from-billing',
  getPayorDataByClientIdAndBillingCodeIdAndTherapyId:
    '/core/billing/get-payer-data-by-client-id-and-billing-code-id-and-therapy-id',
  savePayorDataInBilling: '/core/billing/save-payer-data-in-billing',
  addBulkingCoSignature:
    '/core/billing/add-bulk-co-signature-data-to-session-notes-by-multiple-billing-id',
  getSessionNoteData: '/core/session-note/get-session-note-data-by-session-note-ids',
  //ERA
  getAllERAGridData: '/core/era/get-all-era-grid-data',
  //Payment Reconciliation
  getERADataById: '/core/era/get-era-data-by-id',
  addNoteToERA: '/core/era/add-note',
  //Insurance
  getInsurancePlan: '/core/user-insurance/get-client-insurance-plans',
  //employee onBoarding Authorization
  getAuthorizations: 'core/user-insurance/get-user-authorization-by-client-id',
  getAuthorizationById: 'core/user-insurance/get-user-authorization-setting-data-by-id',
  deleteAuthorization: 'core/user-insurance/delete-client-authorization-by-id',
  getAuthorizationPatientNames: 'core/organization/get-user-childs-by-user-id',
  getPayors: '/core/user-insurance/get-all-user-insurance-dropdown-data',
  saveAuthorization: '/core/user-insurance/save-user-authorization-setting',
  editAuthorization: '/core/user-insurance/upload-user-authorization-file',
  getAllABCDropdownData: '/core/abc-data/get-all-abc-data-dropdown',
  saveABCSessionData: '/core/abc-data/save-abc-data',
  diagnosisCodeUrl: '/core/user-profile/get-all-diagnosis-code',
  PrimaryDiagnosisCode: 'core/user-profile/get-primary-diagnosis-code-by-client-id',
  editInsurance: '/core/user-insurance/get-user-insurance-by-id',
  archiveInsurance: '/core/user-insurance/archive-insurance',
  unarchiveInsurance: '/core/user-insurance/unarchive-insurance',
  clientTherapy: '/core/organization/get-all-therapies-by-organization-id',
  clientTherapyById: '/core/user-insurance/get-desired-therapies-by-child-id',
  //intervention
  sessionNoteDataForInterventionPlan:
    'core/session-note/get-all-paginated-intervention-plan-session-notes-data',
  sesionNoteDataByOrganizationServiceId:
    'core/session-note/get-session-template-data-by-organization-service-id',
  saveSessionNoteForInterventionPlan: 'core/session-note/save-intervention-plan-session-note',
  getInterventioPlanSessionNoteById: 'core/session-note/get-intervention-plan-session-note-by-id',

  getShortTermGoalById:
    '/core/intervention-plan-short-term-goal/get-intervention-plan-short-term-goal-by-id',
  getDomainsByUserType:
    '/core/intervention-plan-domain/get-domains-by-user-type-and-client-of-appointment',
  getIntervenstionDomainsByUserType:
    'core/intervention-plan-domain/get-intervention-plan-domains-for-session-note',
  getInProgressLongTerm:
    '/core/intervention-plan-long-term-goal/get-all-in-progress-long-term-goal',
  getInProgressShortTerm:
    '/core/intervention-plan-short-term-goal/get-all-in-progress-short-term-goal',
  getIntervesntionInProgressLongTerm:
    '/core/intervention-plan-long-term-goal/get-all-intervention-plan-in-progress-long-term-goal',
  getIntervesntionInProgressShortTerm:
    '/core/intervention-plan-short-term-goal/get-all-intervention-plan-in-progress-short-term-goal',
  saveAddShortTermGoalTree:
    '/core/intervention-plan-short-term-goal/change-short-term-goal-status-to-in-progress',
  saveAddLongTermGoalTree:
    '/core/intervention-plan-long-term-goal/change-long-term-goal-status-to-in-progress',
  getNotInprogressGoals:
    '/core/intervention-plan-short-term-goal/get-all-not-in-progress-short-term-goal',
  getLongTermGoalsByUserType:
    '/core/intervention-plan-long-term-goal/get-all-not-in-progress-long-term-goal',
  savePhaseOfIntervention: '/core/intervention-plan/set-phase',
  getClientAssignToIntervention:
    '/core/organization/get-all-clinicians-technicians-by-org-id-and-type',
  getClientServicesIntervention: '/core/organization/get-intervention-plan-services',
  serviceTypeByIntervention: '/core/organization/get-all-services-by-intervention-type',
  InterventionCreate: '/core/intervention-plan/create-intervention-plan',
  addDomainForIntervention: '/core/intervention-plan-domain/create-intervention-plan-domain',
  saveLongTermGoal: '/core/intervention-plan-long-term-goal/save-intervention-plan-long-term-goal',
  saveShortTermGoal:
    '/core/intervention-plan-short-term-goal/save-intervention-plan-short-term-goal',
  changeAssigneeIntervention: '/core/intervention-plan/edit-intervention-plan-assignee',
  InterventionGrid: '/core/intervention-plan/get-all-paginated-intervention-plan',
  saveSecondaryDiagnosisCode: '/core/intervention-plan/save-secondary-diagnosis-code',
  renameEntitiesUrl: '/core/intervention-plan/rename-intervention-plan-entities',
  getInterventionPlanDataByIdUrl: '/core/intervention-plan/get-intervention-plan-by-id',
  getInterventionPlanDataHistoryUrl: '/core//intervention-plan/get-intervention-plan-history',
  getDomainDataByIdUrl: '/core/intervention-plan-domain/get-intervention-plan-domain-by-id',
  getLongTermGoalDataByIdUrl:
    '/core/intervention-plan-long-term-goal/get-intervention-plan-long-term-goal-by-id',
  getShortTermGoalDataByIdUrl:
    '/core/intervention-plan-short-term-goal/get-intervention-plan-short-term-goal-by-id',
  getAllInterventionDomainsUrl: '/core/intervention-plan-domain/get-domain-by-intervention-plan-id',
  getAllInterventionDomainLongTermGoalUrl:
    '/core/intervention-plan-long-term-goal/get-long-term-goal-by-intervention-plan-domain-id',
  getAllInterventionDomainLongTermGoalShortTermUrl:
    '/core/intervention-plan-short-term-goal/get-short-term-goal-by-intervention-plan-long-term-goal-id',
  getAllInterventionDomainLongTermGoalShortTermWithTabsUrl:
    '/core/intervention-plan-short-term-goal/get-short-term-goal-by-intervention-plan-long-term-goal-id-and-status',
  getPrimaryDiagnosisCodeUrl: 'core/user-profile/get-primary-diagnosis-code-by-client-id',
  getAllDiagnosisCodesUrl: '/core/user-profile/get-all-diagnosis-code',
  getGoalScoreUrl: '/core/intervention-plan-short-term-goal/get-goal-score-data',
  getGoalTypeUrl:
    '/core/intervention-plan-short-term-goal/get-intervention-plan-short-term-goal-score-type',
  getAllPhaseForIntervention: '/core/intervention-plan/get-all-phase',
  saveInterventionSave: '/core/intervention-plan-file/save-intervention-plan-file',
  getInterventionPlanFileByInterventionId:
    '/core/intervention-plan-file/get-intervention-plan-file-by-intervention-id',
  saveInterventionPlanDocument: '/core/intervention-plan-document/save-intervention-plan-document',
  countBillingLines: '/core/billing/count-billing-lines',
  getLastThreePrompts: '/core/session/get-last-three-prompts-by-session-id',
  deleteSessionNoteById: '/core/session-note/delete-session-note-data-by-id',
  getSessionRunBySessionAndDate: '/core/session/get-session-run-by-session-and-date',
  getAllSessionByClientId: '/core/session/get-all-session-by-client-id',
  getInterventionDocument: '/core/intervention-plan-document/get-intervention-plan-document-by-id',
  getInterventionByInterventionId:
    '/core/intervention-plan-document/get-intervention-plan-documents-by-intervention-id',
  saveScore: '/core/intervention-plan-short-term-goal/save-short-term-goal-score',
  getScore: '/core/intervention-plan-short-term-goal/get-score-history-by-short-term-goal-id',
  getABCSessionData: '/core/abc-data/get-abc-data-by-session-id',
  deleteSessionById: '/core/session/delete-session',
  allGroups: '/core/authorization-code/get-all-groups-dropdown',
  downloadDocIntervention: '/core/intervention-plan-file/download-intervention-file',
  deleteDocIntervention: '/core/intervention-plan-file/delete-intervention-file',
  deleteIntervention: '/core/intervention-plan/delete-intervention-plan-entities',
  activateInterventionPlan: '/core/intervention-plan/active-intervention-plan',
  getAppointmentDataForInterventionPlanByClientId:
    '/core/session-note/get-appointment-data-for-intervention-plan-by-client-id',
  saveSessionNoteToAppointmentFromInterventionPlan:
    '/core/session-note/save-session-note-to-appointment-from-intervention-plan',
  //Pinned QuickLook
  getQuickLook: 'core/quick-look/get-quick-looks-by-program-book-uuid',
  getAllTargetsByQuickLook: 'core/quick-look/get-all-targets-by-quick-look-id',
  renameQuickLook: 'core/quick-look/rename-quick-look',
  saveTargetsQuickLook: 'core/quick-look/save-targets-quick-look',
  getAllQuickLooksTargets: 'core/quick-look/get-all-quick-look-targets-by-program-book-uuid',
  //goal library
  copyGoalLibrary: '/core/intervention-library/copy-intervention-library',
  goalLibraryDelete: '/core/intervention-library/delete-intervention-library-by-id',
  addGoalLibrary: '/core/intervention-library/save-intervention-library',
  getAllInterventionLibrary: 'core/intervention-library/get-all-intervention-library',
  deleteInterventionibrary: '/core/intervention-library/delete-intervention-library-entities',
  // getAllPhaseForIntervention: '/core/intervention-plan/get-all-phase',
  // saveInterventionSave:
  //     '/core/intervention-plan-file/save-intervention-plan-file',
  // getInterventionPlanFileByInterventionId:
  //     '/core/intervention-plan-file/get-intervention-plan-file-by-intervention-id',
  //Steps Api
  saveStepOrder: '/core/step/set-steps-order',
  editStep: '/core/step/edit-step',
  deleteStep: '/core/step/delete-step-by-id',
  editStepsAddTToAllSteps: '/core/step/add-to-all-steps',
  getGoalLibraryDataByIdUrl: '/core/intervention-library/get-intervention-library-by-id',
  getAllGoalLibraryDomainsUrl:
    '/core/intervention-plan-domain/get-intervention-plan-domain-by-library-id',
  addFromGoalLibrary: '/core/intervention-library/add-from-library',
  saveTrialForTaskAnalysis: '/core/session/save-trail-task-analysis',
  // discharge Api
  dischargeProgramBook: '/core/program-book/discharge-program-book',
  dischargeIntervention: '/core/intervention-plan/discharge-intervention-plan',
  checkDuplicateInProgramBookLibrary: '/core/program-book/check-duplicate-entities',
  checkDuplicateInGoalLibrary: '/core/intervention-library/check-duplicate-entities',
  // meta data management
  placeOfServicesByOrg: '/core/service-place/get-service-places-dropdown',
  diagnosisCodeGrid: '/core/diagnosis-code/get-all-paginated-diagnosis-code',
  saveDiagnosisCode: '/core/diagnosis-code/save-diagnosis-code',
  addPlaceOdservice: '/core/service-place/add-service-places',
  getPlaceOfService: '/core/service-place/get-place-ofService-by-org',
  getDiagnosisCodeById: '/core/diagnosis-code/get-diagnosis-code-by-id',
  changeDiagnosisCodeStatus: '/core/diagnosis-code/change-diagnosis-code-status',
  insuranceGridUrl: '/core/organization-insurance/get-all-paginated-insurance-provider',
  insuranceProviderStatus: '/core/organization-insurance/change-insurance-activation-status',
  insuranceAddNew: '/core/organization-insurance/add-insurance-provider',
  getInsuranveById: '/core/organization-insurance/get-insurance-by-id',
  servicesGrid: '/core/organization-services/get-all-paginated-services',
  emailFormatGrid: '/core/email/get-all-paginated-email-template',
  placeOfServiceGrid: '/core/service-place/get-all-paginated-service-places',
  getEmailById: '/core/email/get-email-template-by-id',
  saveEmail: '/core/email/save-email-template',
  getMultipleUsersOrganizationInfo: '/identity/auth/get-multiple-org-user-info',
  changeServiceStatus: '/core/organization-services/save-service-status',
  changePlaceOfServiceStatus: '/core/service-place/update-service-place-status',
  programBookHistoryUrl: '/core/program-book/get-paginated-program-book-history-data',
  diagnosisCodeHistory: '/core/diagnosis-code/get-paginated-diagnosis-code-history-data',
  insuranceHistory:
    '/core/organization-insurance/get-paginated-organization-insurance-history-data',
  servicesHistory: '/core/organization-services/get-paginated-organization-services-history-data',
  emailFormatHistory: '/core/email/get-paginated-email-template-history-data',
  placeOfserviceHistory: '/core/service-place/get-paginated-service-place-history',
  //OTP
  sendOTP: '/core/auth/send-otp',
  verifyOTP: '/identity/auth/verify-otp',
  getShortTermGraphData:
    '/core/intervention-plan-short-term-goal/get-intervention-short-term-goal-graph-data',
  //Availability
  getTechnicianAvailabilityDays:
    '/core/technician-availability-request/get-technician-availability-data',
  getUnapprovedAvailabilityRequest:
    '/core/technician-availability-request/get-unapproved-technician-availability-request',
  addAvailability: '/core/technician-availability-request/approve-technician-availability-request',
  saveTechnicianAvailability:
    '/core/technician-availability-request/save-technician-availability-request',
  fetchTechniciansAvailability:
    '/core/technician-availability-request/get-technician-availability-data-By-orgId-and-date-range',
  deleteTechniciansAvailability:
    '/core/technician-availability-request/delete-technician-availability-data-By-id',
  //Dictionary
  saveOrganizationDictionary: '/core/dictionary/save-organization-dictionary',
  dictionaryGrid: '/core/dictionary/get-paginated-organization-dictionary',
  deleteDictionary: '/core/dictionary/delete-organization-dictionary',
  getOrganizationDictionaryById: 'core/dictionary/get-organization-dictionary-by-id',
  //dictionary of session note
  getAllWords: '/core/dictionary/get-paginated-dictionary-by-type',
  saveAndEditWords: '/core/dictionary/save-personal-dictionary',
  deleteWords: '/core/dictionary/delete-organization-dictionary',
  //question bank in editor
  getQuestionsAndTherapy: 'core/question-bank-management/get-organization-specific-questions-data',
  getSelectedQuestion: 'core/question-bank-organization/get-organization-selected-questions-data',
  saveSelectedQuestion: 'core/question-bank-organization/save-organization-selected-questions-data',
  getIntakeById: 'core/client-intake-form/get-client-intake-form-by-id',
  clientIntakeFormHistory: 'core/client-intake-form/get-client-intake-form-history-data',
  addPayment: '/core/billing-amount/add-billing-payment',
  getClientPayors: 'core/billing-amount/get-client-all-payer',
  getPaymentTypes: '/core/billing-amount/get-all-payment-type',
  createFormBuilder: '/core/client-intake-form/save-client-intake-form',
  getClientIntakeForm: '/core/client-intake-form/get-paginated-client-intake-form',
  publish: '/core/client-intake-form/publish-client-intake-form',
  unpublish: '/core/client-intake-form/un-publish-client-intake-form',
  // register
  getOrganizationViaIntake: '/core/organization/get-organization-intake-by-uniqueId',
  registerUser: '/core/organization/register-user-via-intake',
  paymentGrid: '/core/billing-amount/get-paginated-billing-amount-data',
  voidPayment: '/core/billing-amount/make-payment-as-void',
  getOrganizationEmployee: '/core/billing-amount/get-organization-alongside-employee-data',
  //user Account
  userAccount: '/core/user-profile//get-user-details-by-user-id',
  getGrandTotal: '/core/billing-amount/get-grand-total-for-all-selected-billing-records',
  getBillingDataByClientIds:
    '/core/billing-amount/get-selected-billing-data-by-client-and-billing-id',
  getAllOwedAmountType: '/core/billing-amount/get-all-owed-amount-type',
  applyBulkPayment: '/core/billing-amount/apply-bulk-payment',
  //Claims
  inboxGridApi: '/core/claims/get-all-paginated-claims',
  deletedClaimGrid: '/core/claims/get-all-deleted-claims',
  deleteClaim: '/core/claims/delete-claim',
  archiveClaim: '/core/claims/archive-claim',
  unarchiveClaim: '/core/claims/un-archive-claim',
  getInsurancesByChildId: '/core/claims/get-insurances-by-child-id',
  getPayorDetailsByInsuranceId: '/core/claims/get-other-payer-details-by-id',
  getSubscriberTypes: '/core/claims/get-all-subscriber-id-type',
  getSubscriberRelationships: '/core/claims/get-all-relation-ship-with-subscriber',
  saveOtherInsured: '/core/claims/save-other-subscriber',
  getAllOtherInsured: '/core/claims/get-all-subscriber-list-by-childId',
  getOtherInsuredDetails: '/core/claims/get-other-subscriber-by-id',
  deleteOtherInsured: '/core/claims/delete-other-subscriber',
  getSecondaryClaimPayorData: '/core/secondary-claim/get-secondary-claim-payer-data',
  generateSecondaryClaim: '/core/secondary-claim/save-secondary-claim',
  getSelectedBillingData:
    '/core/billing-amount/get-selected-billing-data-for-claim-generation-by-billing-id',
  generateClaim: '/core/claims/save-organization-claim',
  getAllClaimByIdType: '/core/claims/get-all-claim-id-type',
  getClaimById: '/core/claims/get-claim-by-id',
  editClaimProviderSupplier: '/core/claims/edit-claim-provider-supplier',
  editClaimProviderBilling: '/core/claims/edit-claim-provider-billing',
  editClaimAddSecondaryQualifier: '/core/claims/edit-claim-add-secondary-qualifiers',
  editSecondaryQualifier: '/core/claims/edit-secondary-qualifiers-by-id',
  deleteSecondaryQualifier: '/core/claims/delete-secondary-qualifiers-by-id',
  getAllSecondaryQualifierDataCategoryByType:
    '/core/claims/get-all-secondary-qualifiers-data-category-by-type',
  getSecondaryQualifierByClaimId: '/core/claims/get-secondary-qualifiers-by-claim-id',
  editClaimFacility: '/core/claims/edit-claim-facility',
  editClaimSupervising: '/core/claims/create-claim-supervising',
  getAllPayorResponsibility: '/core/claims/get-all-payor-responsibility',
  getAllInsuranceIdType: '/core/claims/get-all-insurance-id-type',
  getAllFillingType: '/core/claims/get-all-flling-type',
  getAllInsuranceType: '/core/claims/get-all-insurance-type',
  editClaimInsurance: '/core/claims/save-claim-insurance-data',
  getClientPayor: '/core/claims/get-client-payer-by-payer-and-authorization-code-id',
  getClaimInsuranceDataById: '/core/claims/get-client-insurance-data-by-claim-id',
  getClientPayorInsurance: '/core/claims/get-client-payer-by-payer-and-insurance-id',
  saveClaimServices: '/core/claims/save-claim-services',
  editClaimServices: '/core/claims/edit-claim-service',
  getClaimServicesById: '/core/claims/get-claim-services-by-claim-id',
  getClaimServicesSummaryById: '/core/claims/get-claim-services-summary-by-claim-id',
  generatePatientServicesSummary: '/core/claims/generate-patient-services-summary',
  deleteClaimServicesById: '/core/claims/delete-claim-services-by-id',
  editClaimSubscriber: '/core/claims/save-claim-patient-subscriber',
  getClaimSubcriberById: '/core/claims/get-claim-subscriber-by-claim-id',
  getAllClaimSubcriberIdType: '/core/claims/get-all-subscriber-id-type',
  editClaimPatient: '/core/claims/save-claim-patient',
  getClaimPatientById: '/core/claims/get-claim-patient-by-claim-id',
  getClaimPatientByIdType: '/core/claims/get-all-patient-id-type',
  getAllRelationWithSubscriber: '/core/claims/get-all-relation-ship-with-subscriber',
  editClaimDetails: '/core/claims/save-claim-details',
  getClaimDetailsDropdownData: '/core/claims/get-claim-detail-drop-down-data',
  getClaimDetailsById: '/core/claims/get-claim-details-by-claim-id',
  editClaimDiagnosis: '/core/organization-claim/save-claim-diagnosis-codes-data',
  getDiagnosisCodeByClaimId: '/core/organization-claim/get-diagnosis-codes-by-claim-id',
  getAllDiagnosisCodesDropdownData: '/core/diagnosis-code/get-all-active-diagnosis-codes',
  saveIndividualDiagnosisCode: '/core/organization-claim/save-individual-diagnosis-codes',
  deleteDiagnosisCode: '/core/organization-claim/delete-diagnosis-code-from-claim-data',
  changeDiagnosisCodeType: '/core/organization-claim/change-diagnosis-code-type-from-claim-data',
  getAllUnitQualifier: '/core/claims/get-all-unit-qualifier',
  getNpiNumber: '/core/user-profile/get-user-npi-details-by-user-id',
  getBillingCode: '/core/organization-claim/get-billing-code-by-authorization-id',
  getExistingBillingRecords:
    '/core/organization-claim/get-existing-billing-records-by-client-id-and-authorization-id',
  unDeleteClaim: '/core/claims/un-delete-claim',
  getClaimHistory: '/core/claims/get-claim-history-by-claim-id',
  getAllClaimErrorCount: '/core/claims/get-all-claim-error-count-by-claim-id',
  getPhrases: '/core/dictionary/get-long-form-data-by-phrase',
  getAllLongForm: '/core/dictionary/get-all-long-form-data',
  claimDataByBillerName: '/core/organization/get-details-by-organization-or-user-id-and-type',
  claimICDDiagnosisCode: '/core/claims/get-all-icd-diagnosis-code-indicator',
  claimSetting: '/core/organization-setting/change-claim-setting',
  //authorizations
  authorizationGrid: '/core/client-authorization/get-all-paginated-client-authorization-data',
  authorizationBillingCodes: '/core/client-authorization/get-Billing-code-list-for-dropdown',
  // organization setting
  saveOrganizationSetting: '/core/organization-setting/save-org-setting',
  organizationSettingByOrgId: '/core/organization-setting/get-org-setting-by-organization-id',
  SaveBillerInformation: '/core/organization-setting/save-biller-info',
  saveWaystar: '/core/organization-setting/waystar-integration',
  checkStatusForWaystar: '/core/waystar/send-trigger-file',
  getWaystarStatus: '/core/organization-setting/get-waystar-feature-status',
  isWaystarFeatureEnabled: '/core/organization-setting/is-waystar-feature-enabled',
  editProgressNote: '/core/organization/edit-due-days',
  // medical record
  medicalRecordGrid: '/core/medical-record/get-all-paginated-medical-record',
  getBillToInformation: '/core/billing-amount/get-client-all-private-payer-and-other-payer',
  getBillFromInformation: '/core/invoice/get-billFrom',
  generatePRInvoice: '/core/invoice/generate-invoice',
  generateMedicalRecord: '/core/medical-record/generate-medical-record',
  getMRPayors: '/core/billing-amount/get-client-all-primary-payer',
  getCMSFormsData: '/core/claims/get-cms-form-data-by-claim-id',
  getInvoiceDetailsForPreview: '/core/invoice/preview-invoice',
  getMRDetailsForPreview: '/core/medical-record/preview-medical-record',
  //History
  authorizationHistory: '/core/user-insurance/get-authorization-history-by-user-child-id',
  //user history
  userHistory: '/core/user-profile/get-user-history-by-user-id',
  userChildHistory: '/core/client-children/get-user-child-history-by-id-and-type',
  organizationInsuranceHistory:
    '/core/user-insurance/get-all-paginated-user-insurance-history-data',
  history: '/core/template/get-guide-line-template-history',
  getExportHistoryByClaimId: '/core/claims/get-all-cms-download-record-by-claim-id',
  getExportedDocumentById: '/core/claims/get-cms-download-record-by-id',
  saveClaimsDownloadData: '/core/claims/save-claim-download-data',
  sessionDetailsGrid: '/core/session/get-all-session-details-by-id',
  endSessionInterrupted: 'core/session/end-session-interrupted',
  sendGateway: '/core/waystar/createBatch',
  changeClaimStatus: '/core/claims/change-claim-status-processed',
  terminateBulkSessions: '/core/session/terminate-pending-session-by-ids',
  renameSessionNoteUrl: '/core/session-note/rename-session-note',
  terminateSessionsDetails: '/core/session/get-all-unterminated-session-by-run-user',
  getAllTags: '/core/tags/get-all-tags-by-org-id',
  addNewTag: '/core/tags/add-tag',
  duplicateTagCheck: '/core/tags/duplicate-tag-check',
  editTag: '/core/tags/edit-tag',
  deleteTag: '/core/tags/delete-tag',
  getAllTagsByBilling: '/core/billing/get-all-tags-by-billingId',
  AddTagBilling: '/core/billing/add-tags-to-billing',
  getAppointmentDetailsInBilling: '/core/billing/get-appointment-data-by-billing-id',
  globalBillingSearch: '/core/billing/global-search-billing',
  globalClaimsSearch: '/core/claims/global-search-claim',
  saveLog: '/core/ui-logging/save-logging',
  getSessionRunDetails: '/core/session/get-trails-data-by-session-run-id',
  deleteBulkRecords: '/core/billing/delete-multiple-billing-data-by-billing-ids',
  getNotification: '/core/session-note/get-all-notifications-by-user-id',
  getAuditingNotification:
    '/core/session-note/get-notifications-for-rejected-appointments-by-rejection-type',
  addBulkCosign: '/core/session-note/add-bulk-co-sign-to-session-note',
  technicianAvailabilityNotification:
    '/core/technician-availability-request/get-technician-availability-notification-data',
  acknowledgeNotification:
    '/core/technician-availability-request/acknowledge-technician-availability-notification',
  deleteSessionNoteIntervention: '/core/session-note/delete-intervention-plan-session-notes-data',
  refreshToken: '/identity/auth/refresh-token',
  addBulkTags: '/core/billing/add-tags-to-multiple-billings',
  globalSessionsSearch: '/core/session/global-search-session',
  getSessionRunStatus: '/core/session/get-session-run-status',
  getUnterminatedSessions: '/core/session/get-other-user-unterminated-session-run-data',
  removeFromSession: '/core/session/remove-target-from-session',
  getClinicianAvailability: '/core/scheduler/get-clinician-productivity-data',
  downloadTechnicianAvailability:
    '/core/technician-availability-request/download-technician-availability-data',

  addEventLine: '/core/domain/add-event-line-to-program-book-entities',
  addPhaseChangeLine: '/core/domain/add-manual-phase-change-line-to-program-book-entities',
  exportData: '/core/download-centre/save-exported-document-file',
  getDomainOrProgramGraphData: '/core/domain/get-domain-or-program-graph-data-by-id-and-type',
  //session note in Program Book
  getAllPaginatedSessionNotesInProgramBook:
    '/core/session-note/get-all-paginated-program-book-session-notes-data',
  getProgramBookSessionNoteById: '/core/session-note/get-program-book-session-notes-data-by-id',
  deleteSessionNoteProgramBook: 'core/session-note/delete-program-book-session-notes-data-by-id',
  sessionNoteDataByOrganizationServiceIdForProgramBook:
    'core/session-note/get-program-book-session-template-data-by-organization-service-id',
  saveSessionNoteForProgramBook: '/core/session-note/save-program-book-session-note',
  clientProviderData: '/core/organization/get-program-book-provider-client-data',
  getSecondaryInsurances: '/core/claims/get-secondary-insurance-by-client-id',

  ///secondary claim
  getGroupCode: '/core/claims/get-all-group-code',
  getReasonCode: '/core/claims/get-all-reason-code',
  saveClaimAndAdjustments: '/core/secondary-claim/save-claim-and-service-adjustment',
  deleteClaimAndServiceLine: '/core/secondary-claim/delete-claim-and-service-adjustment-by-id',
  getClaimAndServiceLine: '/core/secondary-claim/get-claim-and-service-adjustment-by-id-and-type',
  downloadGraph: '/core/download-centre/export-short-term-graph',
  saveSecondaryClaimToInbox: '/core/secondary-claim/add-claim-to-inbox',
  CobErrorCount: '/core/claims/get-all-claim-error-count-by-claim-id',
  validateCSVFile: '/core/user-csv/validate-csv',
  importUserData: '/core/user-csv/import-user-data',

  // auto assign request provider
  providerRequestGrip: '/core/scheduler/get-all-auto-assign-provider-list',
  getProviderForClient: '/core/organization/get-provider-for-client',

  // transcription
  saveTranscription: '/core/transcription/save-transcription-by-session-id',
  getTranscription: '/core/transcription/get-transcription-by-run-session-id',
  globalTranscriptionSearch: '/core/transcription/global-search-transcription',
  deleteTranscription: '/core/transcription/delete-transcription-by-id',
  getTranscriptionById: '/core/transcription/get-transcription-by-id',

  //overlapping appointment
  getOverlappingAppointments: '/core/scheduler/get-all-paginated-overlapping-event',
  globalOverlappingAppointmentsSearch: '/core/scheduler/global-searching-overlapping-event',
  exportOverlappingAppointments: '/core/scheduler/export-overlapping-event',
  getOverlappingEvents: '/core/scheduler/get-client-overlapping-event',
  excludeOverlappingEvent: '/core/scheduler/exclude-overlapping-event',

  //pre billing auditing
  getAllRulesData: '/core/organization-setting/get-notes-auditing-rules-master-data',
  saveAuditingData: '/core/organization-setting/save-notes-auditing-settings-data',
  deleteOverlappingAppointment: '/core/scheduler/delete-overlapping-event',
  preBillingAuditingGrid: '/core/scheduler/get-paginated-pre-billing-auditing-grid-data',
  preBillingAuditingGlobalSearch: '/core/scheduler/global-searching-for-pre-billing-auditing-grid',
  billingAuditingHistory: '/core/scheduler/get-paginated-billing-auditing-history-data',
  approveSessionNoteFromAuditing: '/core/scheduler/approve-session-note-from-auditing',
  bulkApproveSessionNoteFromAuditing: '/core/scheduler/bulk-approve-session-note-from-auditing',
  rejectSessionNoteFromAuditing: '/core/scheduler/reject-session-note-from-auditing',
  getSessionNotesAuditingErrorData: '/core/scheduler/get-session-notes-auditing-error-data',

  // Alerts
  getCategoryDataForAlert: '/core/alert/get-category-data-for-alert',
  getRecipientDataForAlert: '/core/alert/get-recipient-data-for-sent-to-client-or-employee',
  saveAlertData: '/core/alert/save-alert-data',
  getAlertDataByStatus: '/core/alert/get-alert-data-by-alert-status',
  getAlertById: '/core/alert/get-alert-by-id',
  markAlertAsRead: '/core/alert/mark-alert-as-read-by-alert-id',
  deleteAlertData: '/core/alert/delete-alert-by-alert-id',

  //session template
  addComponentToLibrary: '/core/component-library/add-component-to-library',
  getComponentLibrary: '/core/component-library/get-paginated-imported-library-component-data',
  getAllPaginatedComponentLibrary: '/core/component-library/get-all-paginated-component-library',
  editLibraryComponent: '/core/component-library/edit-component-library-by-id',
  listofSelectedSessionNotes:
    '/core/component-library/get-paginated-session-template-data-for-dropdown-and-multi-select',
  deleteComponentLibrary: '/core/component-library/delete-component-library-by-id',

  //delete document in program book
  deleteDocument: '/core/document/delete-program-book-document',

  //global search in program book
  globalSearchInProgramBook: '/core/program-book/global-searching-for-program-book-grid',
  globalSearchInInterventionPlan:
    '/core/intervention-plan/global-searching-for-intervention-plan-grid',
  globalSearchInGoalLibrary: '/core/intervention-library/global-searching-for-goal-library-grid',
  globalSearchInProgramBookLibrary: '/core/library/global-searching-for-program-book-library-grid',
  globalSearchForInvoicePr: '/core/invoice/global-search-invoice',
  globalSearchInTemplate: '/core/template/global-searching-for-guideline-and-mastery-grid-by-type',
  globalSearchInMetaDataManagement: '/core/diagnosis-code/global-searching-for-diagnosis-code-grid',
  globalSearchMedicalRecord: '/core/medical-record/global-search-medical-record',
  gloabalGroupSearch: '/core/group/global-search-group',
  globalBiilingCodeSearch: '/core/authorization-code/global-search-authorization-code',
  globalRoleAndPermissionSearch: '/core/authorization/global-search-role',
  globalAutoAssignProvider: '/core/scheduler/global-search-auto-assign-provider-request',
  globalUserSearch: '/core/user-profile/global-search-user-profile',
  getSessionNoteSignedByCredentials: '/core/session-note/get-signed-by-credentials',
  getCredentialsById: '/core/user-profile/get-credentials-by-id',
};
